import request from '@/utils/request'

/**
 * 获取专题列表
 * @param {*} data 
 */
export function getClassroomList(data){
    return request({
      url: '/api/admin/classroom/index',
      method: 'post',
      data
    })
  }

  //创建专题
export function createClassroom(data){
    return request({
      url: '/api/admin/classroom/create',
      method: 'post',
      data
    })
  }
//关闭专题
export function closeClassroom(id){
    return request({
      url: '/api/admin/classroom/'+id+'/close',
      method: 'post'
    })
  }
//关闭专题
export function publishClassroom(id){
    return request({
      url: '/api/classroom/'+id+'/manage/publish',
      method: 'post'
    })
  }

export function getClassroomCompetitionList(params) {
    return request({
      url: '/api/admin/course_set/classroom/index',
      method: 'get',
      params
    })
  }


export function getClassroom(id,params){
    return request({
        url: '/api/classroom/'+id+'/manage/set_info',
        method: 'get',
        params
      })
}

export function updateClassroom(id,data){
    return request({
        url: '/api/classroom/'+id+'/manage/set_info',
        method: 'post',
        data
      })
}

//查找评委
export function getTeacher(id,params) {
  return request({
    url: '/api/classroom/'+id+'/manage/teachers',
    method: 'get',
    params
  })
}

//查找评委
export function searchTeacher(id,params) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/teachers_match',
    method: 'get',
    params
  })
}

//保存评委
export function updateTeachers(id,data) {
  return request({
    url: '/api/classroom/'+id+'/manage/teachers',
    method: 'post',
    data
  })
}

//获取专题成员
export function getClassroomMemberList(id,params) {
  return request({
    url: '/api/classroom/'+id+'/manage/students',
    method: 'get',
    params
  })
}

//检查是否有用户
export function checkClassroomMember(id,params) {
  return request({
    url: '/api/classroom/'+id+'/manage/student_check',
    method: 'get',
    params
  })
}

//添加成员
export function addClassroomMember(id,data) {
  return request({
    url: '/api/classroom/'+id+'/manage/student/create',
    method: 'post',
    data
  })
}

//移除专题成员
export function removeClassroomMember(id,studentId) {
  return request({
    url: '/api/classroom/'+id+'/manage/student/'+studentId+'/remove',
    method: 'post'
  })
}

//获取专题退出成员
export function getClassroomMemberQuitList(id,params) {
  return request({
    url: '/api/classroom/'+id+'/manage/refund_record',
    method: 'get',
    params
  })
}

//获取专题比赛训练
export function getClassroomContest(id,params) {
  return request({
    url: '/api/classroom/'+id+'/manage/courses',
    method: 'get',
    params
  })
}

//专题选择比赛训练列表
export function getClassroomPick(id,params) {
  return request({
    url: '/api/classroom/'+id+'/course/pick',
    method: 'get',
    params
  })
}

//搜索专题选择比赛训练列表
export function searchClassroomPick(id,data) {
  return request({
    url: '/api/classroom/'+id+'/course/search',
    method: 'post',
    data
  })
}

//添加比赛训练
export function addClassroomContest(id,data) {
  return request({
    url: '/api/classroom/'+id+'/courses/select',
    method: 'post',
    data
  })
}

//删除比赛训练
export function removeClassroomCompetition(classroomId,competitionId) {
  return request({
    url: '/api/classroom/'+classroomId+'/manage/course/'+competitionId+'/remove',
    method: 'post'
  })
}

//竞赛调整顺序
export function editClassroomOrder(id,data) {
  return request({
    url: '/api/classroom/'+id+'/manage/courses',
    method: 'post',
    data
  })
}

//前台获取专题列表
export function getClassroomIndex(code,params) {
  if(code){
    var url = "/api/classroom/explore/"+code;
  }else{
    var url = "/api/classroom/explore"
  }
  return request({
    url: url,
    method: 'get',
    params
  })
}

//前台获取专题详情
export function getClassroomCourses(id,params) {
  return request({
    url: '/api/classroom/'+id+'/courses',
    method: 'get',
    params
  })
}

//前台获取专题活动
export function getClassroomCoursesActivity(id,params) {
  return request({
    url: '/api/classroom/'+id+'/courses/activity',
    method: 'get',
    params
  })
}


//加入专题
export function joinClassroom(id) {
  return request({
    url: '/api/order/show?targetId='+id+'&targetType=classroom',
    method: 'get'
  })
}
//退出专题
export function refundClassroom(id) {
  return request({
    url: '/api/target/'+id+'/order/refund?targetType=classroom',
    method: 'post'
  })
}

